<template>
<ValidationObserver ref="observer">
  <form ref="add_daily_closing_form" @submit.prevent="addBusinessUnit">

    <md-card>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-35">
            <div class="md-layout-item md-small-size-100">
                    <label class="md-form-label">Closing Date*</label>
                <validation-provider rules="buname" v-slot="{ errors }">
                  <md-field class="md-invalid">
                    <md-input type="date" v-model="daily_closing_date" v-on:change="onChangeDate" required/>
                    <validation-error :errors="apiValidationErrors.daily_closing_date" />
                    <span class="md-error">{{ errors[0] }}</span>
                  </md-field>
                </validation-provider>
              </div>

              <div class="md-layout-item md-small-size-100">
                <!-- <validation-provider rules="buname" v-slot="{ errors }"> -->
                  <md-field class="md-invalid">
                    <label>Total Amount</label>
                    <md-input v-model="total" disabled/>
                    <validation-error :errors="apiValidationErrors.daily_closing_total_amount" />
                    <!-- <span class="md-error">{{ errors[0] }}</span> -->
                  </md-field>
                <!-- </validation-provider> -->
              </div>

              <div class="md-layout-item md-small-size-100">
                <!-- <validation-provider rules="buname" v-slot="{ errors }"> -->
                  <md-field class="md-invalid">
                    <label>Remark</label>
                    <md-textarea v-model="daily_closing_remark" maxlength="200" md-counter="200" md-autogrow></md-textarea>
                    <validation-error :errors="apiValidationErrors.daily_closing_date" />
                    <!-- <span class="md-error">{{ errors[0] }}</span> -->
                  </md-field>
                <!-- </validation-provider> -->
              </div>
            </div>

          <div class="md-layout-item md-size-65">
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <div class="card-text">
                  <h4 class="title">Payment Data to be Closed</h4>
                </div>
              </md-card-header>
              <md-card-content>
                <md-table>
                  <md-table-row>
                    <md-table-head>No</md-table-head>
                    <md-table-head>Faktur No</md-table-head>
                    <md-table-head>Plate No</md-table-head>
                    <md-table-head>Amount</md-table-head>
                  </md-table-row>
                  <md-table-row v-for="(item,index) in options_item_list" :key="index">
                    <md-table-cell>{{ index+1 }}</md-table-cell>
                    <md-table-cell>{{ item.faktur_no }}</md-table-cell>
                    <md-table-cell>{{ item.faktur_service_estimate.vehicle_types.vehicle_plate_no }}</md-table-cell>
                    <md-table-cell>Rp. {{ formatPrice( item.faktur_total_biaya_jasa + item.faktur_total_biaya_spare_part + item.faktur_materai + item.faktur_ppn ) }}</md-table-cell>
                    <!-- <md-table-cell>Rp. {{ formatPrice( item.faktur_total_biaya_jasa + item.faktur_total_biaya_spare_part + item.faktur_materai + ((item.faktur_total_biaya_jasa + item.faktur_total_biaya_spare_part)*10 /100) ) }}</md-table-cell> -->
                    <!-- <md-table-cell>{{ total }}</md-table-cell> -->
                  </md-table-row>
                </md-table>
              </md-card-content>
            </md-card>

            <!-- <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <div class="card-text">
                  <h4 class="title"></h4>
                </div>
              </md-card-header>
              <md-card-content>
                <md-table>
                  <md-table-tow>
                    <md-table-head>No</md-table-head>
                    <md-table-head>Nota No</md-table-head>
                    <md-table-head>Plate No</md-table-head>
                    <md-table-head>Amount</md-table-head>
                  </md-table-tow>
                  <md-table-row>
                    <md-table-cell>{{ }}</md-table-cell>
                    <md-table-cell>{{ }}</md-table-cell>
                    <md-table-cell>{{ }}</md-table-cell>
                    <md-table-cell>{{ }}</md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </md-card> -->
          </div>
        </div>
        
      </md-card-content>

      <md-card-actions>
        <md-button class="md-info md-dense" @click="addConfirmation">
          Submit
        </md-button>
        <md-button class="md-dense" @click="backtoList">
          Go to List
        </md-button>
      </md-card-actions>
    </md-card>
  </form>
</ValidationObserver>
  
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend , validate, localize , ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Swal from 'sweetalert2';


// mengirim pesan error ketika required field tidak diisi
extend('buname', {
  ...required,
  message: 'Date Field is required'
});
  
  export default {
     name: "add-daily-closing",

    props: {
      data: Object
    },

    components: {ValidationError, ValidationObserver},

    mixins: [formMixin],

    data: () => ({
      daily_closing_date: null,
      daily_closing_total_amount: null,
      daily_closing_remark: null,
      options_item_list: null,
      total:null,
      subtotal:null,
      ppn:null,
    }),

  //   watch: {
  //   options: {
  //     handler() {
  //       if( !this.mounted){
  //         this.getList();
  //       }
  //     },
  //   },
  //   deep: true,
  // },
  //   async mounted() {
  //     this.getList();
  //   },

  // created() {
  //         this.getListNota();
  //     },

  
    methods: {

      async onChangeDate() {
        // ambil list harga item berdasarka dealer yang dipilih
         await this.$store.dispatch("workshop_faktur/faktur_date",this.daily_closing_date)
         this.options_item_list = await this.$store.getters["workshop_faktur/faktur"]

          
         //cari nomor index dari object/array dealer list
        console.log(this.options_item_list);

      this.calculateTotal();


      },

      formatPrice(value) {
        let val = (value/1).toFixed().replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

      calculateTotal(){
          
        var total = 0;
          this.options_item_list.map(function(value, key){
            total = total + value.faktur_total_biaya_jasa + value.faktur_total_biaya_spare_part + value.faktur_materai + value.faktur_ppn
            // ((value.faktur_total_biaya_jasa + value.faktur_total_biaya_spare_part)* 10 / 100) 
              
            
          });
          this.total = total
          
      },

      // async getList(){

      //   if(this.daily_closing_date!=null){
      //   if(query.filter){
      //     Object.assign(query.filter, {belum_closing:this.daily_closing_date});
      //   }
      //   else{
      //     query.filter = {belum_closing:this.daily_closing_date}
      //   }
      // }

      //   await this.$store.dispatch("workshop_nota_part/list");
      // // if (
      // //   (await this.$store.getters["role/list"]) &&
      // //   (await this.$store.getters["role/list"].length) != 0
      // // ) {
      //   this.test = await this.$store.getters["workshop_nota_part/list"];
      // },


      // fungsi untuk tombol direct ke list client master
      backtoList(id) {
      this.$router.replace({ name: 'List Daily Closing' })
    },


     // validasi menggunakan sweetalert  sebelum menambah data
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
    Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.addBusinessUnit()
          }
        });
    },


    // fungsi add data
      async addBusinessUnit() {

        const data = {
          type: "workshop_daily_closings",
          // client_no: this.client_no,
          daily_closing_date: this.daily_closing_date,
          daily_closing_remark: this.daily_closing_remark,
          faktur_daily_closing_id : this.options_item_list
        }


        try {
        await this.$store.dispatch("workshop_daily_closing/add", data);
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        await this.$router.replace({name: 'List Daily Closing'});
      } catch (e) {
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

      }
    }
  };
</script>
